export class SubscriptionsManager {
    constructor() {
        this.unsubs = [];
    }
    subscribe(state, sub) {
        this.unsubs.push(state.subscribe(sub));
    }
    unsubscribeAll() {
        this.unsubs.forEach(unsub => unsub());
        this.unsubs.splice(0);
    }
}
